module.exports = __webpack_public_path__ + "static/Funktionsschema_2-8ee0c1a8126983e6a0780f601865960d.svg";